<template>
<div class="clum2right left">
  <div id="content_block" class="left">
    <div class="account_icon left"> </div>
    <div class="content_title left">My Profile > Change Password</div>
    <div id="content_main" class="left">
      <div class="pure-form pure-form-aligned">
        <fieldset>
          <div class="pure-control-group" style="line-height: 50px;">
            <label  for="newpsw">Reset Password</label>
            <input class="pure-input-2-3" id="newpsw" type="password" placeholder="Password" v-model="newpsw">
          </div>

          <div class="pure-control-group" style="line-height: 50px;">
            <label for="confirmPsw">Confirm Password</label>
            <input class="pure-input-2-3" id="confirmPsw" type="password" placeholder="Confirm Password" v-model="confirmpsw">
          </div>

          <div class="pure-controls" style="margin-left: 170px;">
            <button type="reset" value="Reset" class="button-warning pure-button pure-button-primary" style="width: 160px;" @click="cancel()">Cancel</button>
            <button type="submit" class="button-warning pure-button pure-button-primary" style="width: 160px;" @click="clicksave()">Save</button>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
</div>
</template>
<script>
/*jshint esversion: 6 */
import {getDataUrl} from '../../../tools/getUrl.js';
import router from '../../../router.js';
export default {
  data: function() {
    return {
      modelIsOpen: false,
      newpsw: '',
      confirmpsw: ''
    };
  },
  methods: {
    cancel: function() {
      router.replace('/Main/Profile');
    },
    clicksave: function() {
      var strRightpsw;
      if (this.newpsw === this.confirmpsw) {
        strRightpsw = this.newpsw;
        var obj = {
            api: 'modify_account',
            account_id: sessionStorage.getItem('accountid'),
            passwd: strRightpsw,
            output: 'json'
          },
          url = getDataUrl(obj);
        // btnProfile = this.$els.btnProfile;
        this.$http.get(url).then((response) => {
          // success callback
          if (response.data > 0) {
            sessionStorage.setItem('psw', this.newpsw);
            alert('Your password has been reset.');
            router.replace('/Main/Profile');
          } else {
            alert('Your password has not been reset, please try again.');
          }
        }, (response) => {
          // error callback
        });
      } else {
        alert('Passwords not matched.');
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// Changepsw.vue?17afe597